const NOT_DIGIT = /\D/g;
const PART_LENGTH = 2;
const SHORT_HOUR = /^\d:\d{2}$/;

const digitsOf = (text: string, length: number): string => text.replace(NOT_DIGIT, '').slice(0, length);

export const CLOCK_PATTERN = '([01]\\d|2[0-3]):[0-5]\\d';
export const CLOCK_LENGTH = 5;

export const typedClock = (raw: string): string => {
  const colon = raw.indexOf(':');
  if (colon >= 0) return `${digitsOf(raw.slice(0, colon), PART_LENGTH)}:${digitsOf(raw.slice(colon + 1), PART_LENGTH)}`;
  const digits = digitsOf(raw, PART_LENGTH * 2);
  return digits.length > PART_LENGTH ? `${digits.slice(0, PART_LENGTH)}:${digits.slice(PART_LENGTH)}` : digits;
};

export const settledClock = (typed: string): string => (SHORT_HOUR.test(typed) ? `0${typed}` : typed);
